import { IBusinessDetails } from './business.modal';

export interface IItrInfoSelf {
  return_for: ReturnForType;
  first_name: string;
  middle_name?: string;
  last_name: string;
  // spouse_first_name:string;
  // spouse_middle_name:string;
  // spouse_last_name:string;
  // partner_passed_away_check:boolean;
  // partner_passed_away_date:string;
}
export interface IItrInfo {
  return_for: ReturnForType;
  first_name: string;
  middle_name?: string;
  last_name: string;
  // spouse_first_name:string;
  // spouse_middle_name:string;
  // spouse_last_name:string;
  // partner_passed_away_check:boolean;
  // partner_passed_away_date:string;
}

export const enum ReturnForType {
  'self',
  'partner',
  'other'
}
export interface IExtendedItr extends IItrInfo {
  id: number;
  state: string;
}

export interface IItrFormatted {
  id: number;
  firstName: string;
  middleName?: string;
  lastName: string;
  userType: ReturnForType;
  spouseFirstName: string;
}

export class User {
  id: number | null;
  firstName: string;
  middleName?: string;
  lastName: string;
  email: string;
  userName: string;
  fullName: string;
  message?: string;
  constructor(json: User) {
    Object.assign(this, json);
  }
}

export interface IProfile {
  buisnessDetails: IBusinessDetails;
  mailingDetails: IMailingDetails;
  profileDetails: IProfileDetails;
}

export interface IProfileDetails {
  newReturn: IExtendedItr;
  marital: IMaritalStatus;
  dependents: IItrBackgroundDetails;
  completeDetails: IItrCompleteProfile;
}

export interface IMaritalStatus {
  id: number | null;
  itr: number;
  marital_status: MaritalStatusEnum;
  marital_status_change?: boolean;
  marital_status_before_change: string;
  date_of_change?: string;
}

export interface IMaritalStatusFormatted {
  id: number | null;
  itr: number;
  type: string;
  isMaritalStatusChanged?: boolean;
  maritalStatusList: string;
  dateOfChanging?: ICalendarDate;
}

export interface ICalendarDate {
  year: number;
  month: number;
  day: number;
}

export interface IItrApiResponse {
  data: IMaritalStatus | IItrCommonCompleteProfile | IExtendedItr | IMailingDetails | IItrBackgroundDetails;
  status_code: string;
}

export const enum MaritalStatusEnum {
  'single',
  'divorced',
  'widowed',
  'separated',
  'married',
  'living'
}
export interface IItrCommonCompleteProfile {
  id: number | null;
  itr: number;
  sin: string;
  phone: number;
  email: string;
}
export interface IItrCompleteProfile extends IItrCommonCompleteProfile {
  first_name: string;
  last_name: string;
  middle_name?: string;
  dob: string;
  sex: string;
  language: string;
  canadian_citizenship_indicator: boolean;
  elections_canada_authorization_indicator: boolean;
  canadian_indian_indicator: boolean;
  first_time_filer: number;
  filling_prior_years_returns: boolean;
  accessCode: string;
}

export interface IItrCompleteProfileFormatted extends IItrCommonCompleteProfile {
  firstName: string;
  lastName; string;
  middleName?: string;
  dob: ICalendarDate;
  sex: number;
  language: number;
  canadianCitizenshipIndicator: boolean;
  electionsCanadaAuthorizationIndicator: boolean;
  fillingPriorYearsReturns: boolean;
  incomeTaxExemptIndianActIndicator: boolean;
  firstTimeFilerIndicator: boolean;
  accessCode: string;
}

export interface IMailingCommonDetails {
  id: number | null;
  street: string;
  apartment: string;
  province: number;
  city: string;
  itr: number;
}

export interface IMailingDetails extends IMailingCommonDetails {
  po_box: string;
  rural_route: string;
  postal_code: string;
  date_of_moving: string;
  current_province: number;
  taxpayer_year_end_residence_province_code: number;
}

export interface IMailingDetailsFormatted extends IMailingCommonDetails {
  poBox: string;
  ruralRoute: string;
  postalCode: string;
  dateOfMoving: ICalendarDate;
  currentProvince: number;
  taxpayerYearEndResidenceProvinceCode: number;
}

export interface IItrBackgroundDetails {
  id: number | null;
  itr: number;
  business: boolean;
  prison: boolean;
  dependants: IItrDependents[];
  drug_insurance_program: string;
  living_alone: boolean;
  email_conditions: boolean;
}

export interface IItrBackgroundFormatted {
  id: number | null;
  itr: number;
  business: boolean;
  prison: boolean;
  isDependentsRequired: boolean;
  dependants: IItrDependentsFormatted[];
  drugInsuranceProgram: boolean;
  livingAlone: boolean;
  emailConditions: boolean;
}

export interface IItrDependents {
  first_name: string;
  last_name: string;
  relationship: string;
  sin: string;
  dob: string;
  id: number | null;
  is_living_with_user: boolean;
  province: number;
  is_income_zero: boolean;
  net_income: number | null;
  total_split_income: number | null;
  is_student: boolean;
  is_qualified_for_disability_tax_credit: boolean;
  deductions_from_net_income: number | null;
  federal_non_refundable_credits: number | null;
  provincial_non_refundable_credits: number | null;
}

export interface IItrDependentsFormatted {
  firstName: string;
  lastName: string;
  relationship: string;
  sin: string;
  dob: ICalendarDate;
  id: number | null;
}

export interface CraApiResponse {
  data: Craresponse;
  status_code: string;
}

export interface Craresponse {
  response: string;
}
